import React, { useState, useEffect } from 'react';

const SummerSceneOverlay = () => {
  const [seagulls, setSeagulls] = useState([]);

  useEffect(() => {
    // Generate flying seagulls
    const generateSeagulls = () => {
      const birds = [];
      for (let i = 0; i < 5; i++) {
        birds.push({
          id: i,
          left: Math.random() * 100,
          animationDuration: 15 + Math.random() * 10,
          animationDelay: Math.random() * 8,
          size: 20 + Math.random() * 15,
          yPosition: 10 + Math.random() * 40,
        });
      }
      setSeagulls(birds);
    };
    
    generateSeagulls();
  }, []);

  return (
    <div className="summer-beach-overlay">
      <style jsx>{`
        .summer-beach-overlay {
          position: fixed;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 0;
          pointer-events: none;
          overflow: hidden;
        }

        /* Bright tropical sky */
        .tropical-sky {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            to bottom,
            #87CEEB 0%,
            #98D8F4 25%,
            #A9E2FA 50%,
            #BAEBFF 75%,
            #D4F1FF 100%
          );
          z-index: 0;
          opacity: 1;
        }

        /* Bright sun */
        .bright-sun {
          position: absolute;
          top: 12%;
          right: 18%;
          width: 80px;
          height: 80px;
          background: radial-gradient(
            circle,
            #FFF9E6 0%,
            #FFEB99 30%,
            #FFD700 70%,
            #FFC700 100%
          );
          border-radius: 50%;
          box-shadow: 
            0 0 40px rgba(255, 235, 153, 0.8),
            0 0 80px rgba(255, 215, 0, 0.6),
            0 0 120px rgba(255, 199, 0, 0.4);
          animation: sunGlow 4s ease-in-out infinite;
          z-index: 1;
          opacity: 1;
        }

        @keyframes sunGlow {
          0%, 100% { 
            transform: scale(1);
            box-shadow: 
              0 0 40px rgba(255, 235, 153, 0.8),
              0 0 80px rgba(255, 215, 0, 0.6),
              0 0 120px rgba(255, 199, 0, 0.4);
          }
          50% { 
            transform: scale(1.05);
            box-shadow: 
              0 0 50px rgba(255, 235, 153, 0.9),
              0 0 90px rgba(255, 215, 0, 0.7),
              0 0 130px rgba(255, 199, 0, 0.5);
          }
        }

        /* Fluffy clouds */
        .summer-cloud {
          position: absolute;
          background: rgba(255, 255, 255, 0.9);
          border-radius: 100px;
          opacity: 1;
          animation: cloudDrift linear infinite;
          box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
          z-index: 1;
        }

        @keyframes cloudDrift {
          0% { transform: translateX(0); }
          100% { transform: translateX(100vw); }
        }

        /* Palm trees - left side */
        .palm-left {
          position: absolute;
          bottom: 20%;
          left: 5%;
          width: 120px;
          height: 400px;
          z-index: 3;
          opacity: 1;
        }

        /* Palm trees - right side */
        .palm-right {
          position: absolute;
          bottom: 20%;
          right: 5%;
          width: 120px;
          height: 400px;
          z-index: 3;
          opacity: 1;
        }

        .palm-trunk {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 35px;
          height: 100%;
          background: linear-gradient(
            90deg,
            #8B6F47 0%,
            #A0825A 30%,
            #B8956D 50%,
            #A0825A 70%,
            #8B6F47 100%
          );
          border-radius: 18px 18px 0 0;
          box-shadow: 0 8px 25px rgba(0, 0, 0, 0.4);
        }

        .palm-frond {
          position: absolute;
          background: linear-gradient(
            45deg,
            #228B22 0%,
            #32CD32 50%,
            #228B22 100%
          );
          border-radius: 50%;
          animation: palmSway 8s ease-in-out infinite;
          box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
          opacity: 1;
        }

        @keyframes palmSway {
          0%, 100% { transform: rotate(0deg); }
          50% { transform: rotate(5deg); }
        }

        /* Ocean waves */
        .ocean-waves {
          position: absolute;
          bottom: 15%;
          left: 0;
          width: 100%;
          height: 25%;
          background: linear-gradient(
            to bottom,
            rgba(0, 119, 190, 0.8) 0%,
            rgba(0, 149, 218, 0.85) 30%,
            rgba(0, 180, 216, 0.9) 60%,
            rgba(0, 191, 255, 0.95) 100%
          );
          z-index: 5;
          opacity: 1;
        }

        .wave-pattern {
          position: absolute;
          width: 100%;
          height: 100%;
          background: repeating-linear-gradient(
            90deg,
            transparent 0px,
            rgba(255, 255, 255, 0.1) 30px,
            transparent 60px
          );
          animation: waveFlow 3s linear infinite;
        }

        @keyframes waveFlow {
          0% { transform: translateX(0); }
          100% { transform: translateX(60px); }
        }

        /* Beach sand */
        .beach-sand {
          position: absolute;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 15%;
          background: linear-gradient(
            to bottom,
            #F4E4C1 0%,
            #EDD9B0 40%,
            #E6CE9F 70%,
            #DFC38E 100%
          );
          z-index: 6;
          box-shadow: 0 -10px 30px rgba(0, 0, 0, 0.2);
          opacity: 1;
        }

        .sand-texture {
          position: absolute;
          width: 100%;
          height: 100%;
          background: repeating-linear-gradient(
            45deg,
            transparent 0px,
            rgba(139, 90, 43, 0.02) 1px,
            transparent 2px,
            transparent 4px
          );
        }

        /* Beach umbrella */
        .beach-umbrella {
          position: absolute;
          bottom: 18%;
          z-index: 7;
          opacity: 1;
        }

        .umbrella-pole {
          position: absolute;
          bottom: 0;
          left: 50%;
          transform: translateX(-50%);
          width: 6px;
          height: 90px;
          background: linear-gradient(
            180deg,
            #8B4513 0%,
            #A0522D 50%,
            #8B4513 100%
          );
          border-radius: 3px;
          box-shadow: 2px 0 8px rgba(0, 0, 0, 0.4);
        }

        .umbrella-canopy {
          position: absolute;
          bottom: 75px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
          border-left: 50px solid transparent;
          border-right: 50px solid transparent;
          border-bottom: 40px solid transparent;
          filter: drop-shadow(0 8px 20px rgba(0, 0, 0, 0.3));
        }

        .umbrella-stripe {
          position: absolute;
          bottom: 75px;
          left: 50%;
          transform: translateX(-50%);
          width: 0;
          height: 0;
        }

        /* Beach chair */
        .beach-chair {
          position: absolute;
          bottom: 20%;
          z-index: 7;
          opacity: 1;
        }

        .chair-frame {
          position: absolute;
          bottom: 0;
          width: 50px;
          height: 35px;
          border: 3px solid #CD853F;
          border-radius: 5px;
          background: linear-gradient(
            135deg,
            #FF6B6B 0%,
            #FF8787 50%,
            #FF6B6B 100%
          );
          box-shadow: 0 6px 15px rgba(0, 0, 0, 0.4);
        }

        .chair-stripe {
          position: absolute;
          width: 100%;
          height: 6px;
          background: #FFE5E5;
        }

        /* Surfboard */
        .surfboard {
          position: absolute;
          bottom: 18%;
          width: 18px;
          height: 80px;
          background: linear-gradient(
            180deg,
            #FF1493 0%,
            #FF69B4 50%,
            #FF1493 100%
          );
          border-radius: 9px;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.4);
          z-index: 7;
          opacity: 1;
          transform: rotate(15deg);
        }

        /* Beach ball */
        .beach-ball {
          position: absolute;
          border-radius: 50%;
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.3);
          z-index: 7;
          opacity: 1;
          animation: beachBallBounce 3s ease-in-out infinite;
        }

        @keyframes beachBallBounce {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }

        .ball-segment {
          position: absolute;
          width: 100%;
          height: 100%;
          border-radius: 50%;
          opacity: 0.8;
        }

        /* Flying seagull */
        .seagull {
          position: absolute;
          animation: seagullFly linear infinite;
          z-index: 2;
          opacity: 1;
        }

        @keyframes seagullFly {
          0% { 
            transform: translateX(-100px) translateY(0);
          }
          50% {
            transform: translateX(50vw) translateY(-20px);
          }
          100% { 
            transform: translateX(calc(100vw + 100px)) translateY(0);
          }
        }

        .seagull-body {
          width: 100%;
          height: 60%;
          background: #FFFFFF;
          border-radius: 50%;
          position: relative;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
        }

        .seagull-wing {
          position: absolute;
          width: 80%;
          height: 3px;
          background: #FFFFFF;
          top: 50%;
          left: 50%;
          transform: translateX(-50%) translateY(-50%);
          animation: wingFlap 1s ease-in-out infinite;
          box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
        }

        @keyframes wingFlap {
          0%, 100% { transform: translateX(-50%) translateY(-50%) scaleX(1); }
          50% { transform: translateX(-50%) translateY(-50%) scaleX(1.3); }
        }

        /* Starfish */
        .starfish {
          position: absolute;
          bottom: 8%;
          width: 25px;
          height: 25px;
          background: #FF6347;
          clip-path: polygon(50% 0%, 61% 35%, 98% 35%, 68% 57%, 79% 91%, 50% 70%, 21% 91%, 32% 57%, 2% 35%, 39% 35%);
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
          z-index: 8;
          opacity: 1;
        }

        /* Seashell */
        .seashell {
          position: absolute;
          bottom: 6%;
          width: 18px;
          height: 20px;
          background: linear-gradient(
            135deg,
            #FFE4E1 0%,
            #FFC0CB 50%,
            #FFB6C1 100%
          );
          border-radius: 50% 50% 50% 0;
          box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
          z-index: 8;
          opacity: 1;
        }

        /* Responsive design */
        @media (max-width: 768px) {
          .palm-left,
          .palm-right { height: 300px; width: 90px; }
          .beach-umbrella { transform: scale(0.8); }
          .beach-chair { transform: scale(0.8); }
          .bright-sun { width: 60px; height: 60px; }
        }
      `}</style>

      {/* Bright tropical sky */}
      <div className="tropical-sky" />

      {/* Bright sun */}
      <div className="bright-sun" />

      {/* Fluffy clouds */}
      {[
        { left: '10%', top: '15%', width: 80, height: 30, duration: 60 },
        { left: '35%', top: '20%', width: 100, height: 35, duration: 80 },
        { left: '65%', top: '12%', width: 90, height: 32, duration: 70 },
      ].map((cloud, i) => (
        <div
          key={i}
          className="summer-cloud"
          style={{
            left: cloud.left,
            top: cloud.top,
            width: `${cloud.width}px`,
            height: `${cloud.height}px`,
            animationDuration: `${cloud.duration}s`,
          }}
        >
          <div style={{
            position: 'absolute',
            left: '20%',
            top: '-30%',
            width: '50%',
            height: '60%',
            background: 'inherit',
            borderRadius: '50%',
          }} />
          <div style={{
            position: 'absolute',
            right: '20%',
            top: '-40%',
            width: '40%',
            height: '70%',
            background: 'inherit',
            borderRadius: '50%',
          }} />
        </div>
      ))}

      {/* Left palm tree */}
      <div className="palm-left">
        <div className="palm-trunk" />
        {[
          { rotation: -45, width: 80, height: 35, delay: 0 },
          { rotation: -15, width: 85, height: 38, delay: 0.3 },
          { rotation: 15, width: 85, height: 38, delay: 0.6 },
          { rotation: 45, width: 80, height: 35, delay: 0.9 },
          { rotation: -75, width: 70, height: 30, delay: 1.2 },
          { rotation: 75, width: 70, height: 30, delay: 1.5 },
        ].map((frond, i) => (
          <div
            key={i}
            className="palm-frond"
            style={{
              top: '10px',
              left: '50%',
              width: `${frond.width}px`,
              height: `${frond.height}px`,
              transform: `translateX(-50%) rotate(${frond.rotation}deg)`,
              transformOrigin: 'bottom center',
              animationDelay: `${frond.delay}s`,
            }}
          />
        ))}
      </div>

      {/* Right palm tree */}
      <div className="palm-right">
        <div className="palm-trunk" />
        {[
          { rotation: -45, width: 80, height: 35, delay: 0.2 },
          { rotation: -15, width: 85, height: 38, delay: 0.5 },
          { rotation: 15, width: 85, height: 38, delay: 0.8 },
          { rotation: 45, width: 80, height: 35, delay: 1.1 },
          { rotation: -75, width: 70, height: 30, delay: 1.4 },
          { rotation: 75, width: 70, height: 30, delay: 1.7 },
        ].map((frond, i) => (
          <div
            key={i}
            className="palm-frond"
            style={{
              top: '10px',
              left: '50%',
              width: `${frond.width}px`,
              height: `${frond.height}px`,
              transform: `translateX(-50%) rotate(${frond.rotation}deg)`,
              transformOrigin: 'bottom center',
              animationDelay: `${frond.delay}s`,
            }}
          />
        ))}
      </div>

      {/* Ocean waves */}
      <div className="ocean-waves">
        <div className="wave-pattern" />
      </div>

      {/* Beach sand */}
      <div className="beach-sand">
        <div className="sand-texture" />
      </div>

      {/* Beach umbrellas */}
      {[
        { left: '25%', colors: ['#FF6B6B', '#FFE66D'], stripes: true },
        { left: '45%', colors: ['#4ECDC4', '#FFE66D'], stripes: true },
        { left: '65%', colors: ['#FF6B6B', '#4ECDC4'], stripes: true },
      ].map((umbrella, i) => (
        <div
          key={i}
          className="beach-umbrella"
          style={{ left: umbrella.left }}
        >
          <div className="umbrella-pole" />
          {umbrella.stripes && [0, 1, 2, 3, 4].map((stripe) => (
            <div
              key={stripe}
              className="umbrella-stripe"
              style={{
                borderLeft: '10px solid transparent',
                borderRight: '10px solid transparent',
                borderBottom: `40px solid ${umbrella.colors[stripe % 2]}`,
                marginLeft: `${(stripe - 2) * 20}px`,
              }}
            />
          ))}
        </div>
      ))}

      {/* Beach chairs */}
      {[
        { left: '30%' },
        { left: '50%' },
        { left: '70%' },
      ].map((chair, i) => (
        <div
          key={i}
          className="beach-chair"
          style={{ left: chair.left }}
        >
          <div className="chair-frame">
            <div className="chair-stripe" style={{ top: '10%' }} />
            <div className="chair-stripe" style={{ top: '50%' }} />
          </div>
        </div>
      ))}

      {/* Surfboard */}
      <div className="surfboard" style={{ left: '15%' }} />

      {/* Beach ball */}
      <div
        className="beach-ball"
        style={{
          bottom: '17%',
          left: '80%',
          width: '35px',
          height: '35px',
        }}
      >
        <div className="ball-segment" style={{
          background: 'linear-gradient(135deg, #FF6B6B 0%, #FF6B6B 50%, transparent 50%)',
        }} />
        <div className="ball-segment" style={{
          background: 'linear-gradient(225deg, #4ECDC4 0%, #4ECDC4 50%, transparent 50%)',
        }} />
        <div className="ball-segment" style={{
          background: 'linear-gradient(315deg, #FFE66D 0%, #FFE66D 50%, transparent 50%)',
        }} />
        <div className="ball-segment" style={{
          background: 'linear-gradient(45deg, #95E1D3 0%, #95E1D3 50%, transparent 50%)',
        }} />
      </div>

      {/* Flying seagulls */}
      {seagulls.map((bird) => (
        <div
          key={bird.id}
          className="seagull"
          style={{
            left: `${bird.left}%`,
            top: `${bird.yPosition}%`,
            width: `${bird.size}px`,
            height: `${bird.size}px`,
            animationDuration: `${bird.animationDuration}s`,
            animationDelay: `${bird.animationDelay}s`,
          }}
        >
          <div className="seagull-body" />
          <div className="seagull-wing" />
        </div>
      ))}

      {/* Starfish on sand */}
      {[
        { left: '20%' },
        { left: '55%' },
        { left: '85%' },
      ].map((star, i) => (
        <div
          key={i}
          className="starfish"
          style={{
            left: star.left,
            transform: `rotate(${i * 30}deg)`,
          }}
        />
      ))}

      {/* Seashells on sand */}
      {[
        { left: '35%' },
        { left: '62%' },
        { left: '78%' },
      ].map((shell, i) => (
        <div
          key={i}
          className="seashell"
          style={{
            left: shell.left,
            transform: `rotate(${i * 45}deg)`,
          }}
        />
      ))}
    </div>
  );
};

export default SummerSceneOverlay;
